import AppError from "@/pages/errors/AppErrorPage";
import * as Sentry from "@sentry/react";
import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import { FC, ReactNode, Suspense } from "react";
import TopBarProgress from "react-topbar-progress-indicator";
import colors from "tailwindcss/colors";
interface SuspenseRouteProps {
  children: ReactNode;
}

const SuspenseRoute: FC<SuspenseRouteProps> = ({ children }) => {
  const { reset } = useQueryErrorResetBoundary();
  const baseColor = colors.lime["600"];
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });

  return (
    <Sentry.ErrorBoundary
      onReset={reset}
      fallback={({ resetError }) => <AppError handleCallback={resetError} />}
    >
      <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
    </Sentry.ErrorBoundary>
  );
};

export default SuspenseRoute;
